// extracted by mini-css-extract-plugin
export var divider = "_mn-0";
export var systemMessage = "_mn-1";
export var systemMessageWrapper = "_mn-2";